import EmployeePayrollReportComponent from "features/Report/components/SalaryGroup/EmployeePayrollReport";
import useEmployeePayrollReport from "features/Report/hooks/salaryGroup/useEmployeePayrollReport";

const EmployeePayrollReportPage = () => {
    const employeePayrollReportProps = useEmployeePayrollReport();
    return <EmployeePayrollReportComponent {...employeePayrollReportProps} />
}

export default EmployeePayrollReportPage;